import HowItWorks from "../components/HowItWorks";
import MyDataCheckSection from "../components/MyDataCheckSection";
import Navbar from "../components/Navbar";
import SectionDemo from "../components/SectionDemo";
import SectionFact from "../components/SectionFact";
import Testimonials from "../components/Testimonial";
import Footer from "./Footer";
import { motion } from "framer-motion";
import { fadeIn, textVariant } from "../utils/motion";
import { useTranslation } from "react-i18next"
import ClientGuideAnimated from "../components/ClientGuideAnimated";
export default function Home() {

    const { t } = useTranslation();
  return (
    <>
      <div className="relative z-10 bottom-5 hidden dark:block ">
        <Navbar />
      </div>
      <div className="relative z-10 bottom-5 dark:hidden block ">
        <Navbar />
      </div>
      {/* BACKGROUND EN ARRIÈRE PLAN */}
      <div className="background hidden  dark:block ">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="background2 dark:hidden block">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>

      {/* CONTENU PAR DESSUS */}
      <div className="relative z-10">
        <div className="flex items-center justify-center h-full ">
          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.25 }}
            className="p-6"
          >
            <motion.h1
              variants={textVariant(0.2)}
              className="text-3xl font-bold mb-4 text-center text-white dark:text-white"
            >
              {t("welcome")}
            </motion.h1>

            <motion.p
              variants={fadeIn("up", "spring", 0.4, 1)}
              className="text-white dark:text-white text-center font-bold"
            >
             {t("welcome1")}
            </motion.p>
          </motion.div>
        </div>
        <HowItWorks />
        <Testimonials />
        <SectionFact />
        <SectionDemo />
        <ClientGuideAnimated />
        <MyDataCheckSection />
      </div>
      <div className="relative z-10 top-14">
        <Footer />
      </div>
    </>
  );
}
